import * as React from 'react';
import { connect } from 'react-redux';

// Components
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';

// Actions
// @ts-ignore
import { requestDeleteTimesheet } from 'services/timesheets/actions';

interface OwnProps {
    timesheetId: number;
}

interface DispatchProps {
    requestDeleteTimesheet: Function;
}

export interface Props extends OwnProps, DispatchProps { }

export class TimesheetDeleteModalButton extends React.PureComponent<Props> {
    public handleClick = (): void => {
        const { timesheetId } = this.props;
        this.props.requestDeleteTimesheet(timesheetId);
    };

    public render(): JSX.Element {
        return (
            <SubmittingButton
                type="submit"
                namespace="TIMESHEET_DELETE"
                negative
                fluid
                onClick={this.handleClick}
            >
                Delete
            </SubmittingButton>
        );
    }
}

export default connect<{}, DispatchProps, OwnProps>(
    null,
    { requestDeleteTimesheet }
)(TimesheetDeleteModalButton);
